<template>
  <div class="user-details-container">
    <div class="info-layout">
      <h3>
        Information
        <el-tooltip class="item" effect="dark" content="Reset" placement="top">
          <icon-button icon="el-icon-refresh" @click="reset" />
        </el-tooltip>
      </h3>
    </div>
    <div class="input-group">
      <dg-input type="text" v-model="formData.name" placeholder="Name" icon="user" />
      <dg-input type="text" v-model="formData.email" placeholder="E-mail" icon="at" fa />
      <dg-input type="text" v-model="formData.phoneNumber" placeholder="Phone" icon="phone" />
      <dg-input type="text" v-model="formData.address" placeholder="Address" icon="map-pin" />
      <div class="input-grouped">
        <dg-input type="text" v-model="formData.city" placeholder="City" icon="info" fa />
        <dg-input type="text" v-model="formData.zip" placeholder="Zip" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserDetails',
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  watch: {
    formData: {
      handler () {
        this.$emit('change', this.formData)
      },
      deep: true
    }
  },
  data () {
    return {
      formData: {
        name: this.user.name,
        email: this.user.email,
        phoneNumber: this.user.phoneNumber,
        address: this.user.address,
        city: this.user.city,
        zip: this.user.zip
      }
    }
  },
  methods: {
    reset () {
      this.formData.name = this.user.name
      this.formData.email = this.user.email
      this.formData.phoneNumber = this.user.phoneNumber
      this.formData.address = this.user.address
      this.formData.city = this.user.city
      this.formData.zip = this.user.zip

      this.$emit('change', this.formData)
    }
  },
  created () {
    this.$emit('change', this.formData)
  }
}
</script>

<style lang="scss" scoped>
  .info-layout {
    padding: 20px 0px 20px 0px;

    h3 {
      padding: 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/profile/UserDetails.vue